export const getQuestionNumber = (sectionNumber, question) => (
  `${sectionNumber}` +
  `${question.checklistQuestionIdAlias || question.checklistQuestion.currentVersion.checklistQuestionIdAlias || `${question.position + 1}.`}`
);
